export const generateLink = (
  to,
  basePath = '/',
  search,
  ) => {
  // return URL if URL is fully qualified
  if (to.toLocaleLowerCase().startsWith('http')) {
    return new URL(to);
  }
  
  const navigatePath = !to
    ? basePath
    : to[0] === '/'
    ? to
    : `${basePath}/${to}`;
  return new URL(
    `${navigatePath}${search ?? window.location.search}`,
      window.location.origin,
    );
  };
  
export const navigateTo = (
  to,
  basePath = '/',
  search,
  ) => {
  const url = generateLink(to, basePath, search);
  window.history.pushState({ isCustomRouterStateChange: true }, '', url.href);
  window.dispatchEvent(new PopStateEvent('popstate'));
  
  return url;
};
